import {
  ApiBlueprint,
  createApiFactory,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  catalogApiRef,
  entityPresentationApiRef,
} from '@backstage/plugin-catalog-react';
import { DefaultEntityPresentationApi } from '@backstage/plugin-catalog';
import { ResilientEntityPresentationApi } from '../../lib/ResilientEntityPresentationApi';
import { userAnnotationFilters } from './filters';
import {
  catalogIndexPageOverride,
  catalogUserListFilterOverride,
} from './catalogIndexPage';
import { catalogEntityPageOverride } from './entityPage';

// Guards against an upstream crash: @backstage/plugin-org's OwnershipCard
// puts the *humanized* owner name (not a qualified ref) into the Catalog
// page's ?filters[owners]= link, and @backstage/plugin-catalog-react's
// EntityOwnerPicker round-trips that bare string into this API with no
// default-kind context, hitting an unguarded parseEntityRef inside
// @backstage/plugin-catalog's DefaultEntityPresentationApi. Reproduces for
// every team, regardless of how that team's own catalog-info.yaml spells
// its owner field. See ResilientEntityPresentationApi for the full trace.
export function createEntityPresentationApi({
  catalogApi,
}: {
  catalogApi: typeof catalogApiRef.T;
}) {
  return new ResilientEntityPresentationApi(
    DefaultEntityPresentationApi.create({ catalogApi }),
  );
}

// The extension name deliberately matches the alpha catalog plugin's own
// (`api:catalog/entity-presentation`, PAT-1027), so this module replaces it
// instead of being rejected with API_FACTORY_CONFLICT. Pinned by index.test.ts.
export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    ApiBlueprint.make({
      name: 'entity-presentation',
      params: defineParams =>
        defineParams(
          createApiFactory({
            api: entityPresentationApiRef,
            deps: { catalogApi: catalogApiRef },
            factory: createEntityPresentationApi,
          }),
        ),
    }),
    catalogIndexPageOverride,
    catalogUserListFilterOverride,
    ...userAnnotationFilters,
    catalogEntityPageOverride,
  ],
});
